var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.2846 3H11.7296C6.26964 3 3.01465 6.255 3.01465 11.715V24.27C3.01465 29.73 6.26964 32.985 11.7296 32.985H24.2846C29.7446 32.985 32.9996 29.73 32.9996 24.27V11.715C32.9996 6.255 29.7446 3 24.2846 3Z",
    fill: "#FE9899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2497 12.135V25.875C17.2497 26.415 16.7097 26.775 16.2147 26.565C14.3997 25.785 12.0297 25.065 10.3797 24.855L10.0947 24.825C9.17967 24.705 8.42969 23.85 8.42969 22.92V11.37C8.42969 10.23 9.35969 9.375 10.4997 9.465C12.3747 9.615 15.1497 10.515 16.8897 11.505C17.1147 11.61 17.2497 11.865 17.2497 12.135Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.57 11.55V22.905C27.57 23.835 26.82 24.69 25.905 24.81L25.59 24.84C23.955 25.065 21.6 25.77 19.785 26.535C19.29 26.745 18.75 26.385 18.75 25.845V12.1199C18.75 11.8499 18.885 11.595 19.125 11.46C20.865 10.485 23.58 9.61495 25.425 9.44995H25.485C26.64 9.46495 27.57 10.395 27.57 11.55Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSquare);
export default __webpack_public_path__ + "static/media/book-square.a8d2d2fbb878ed22b118978106616b7f.svg";
export { ForwardRef as ReactComponent };